import { getCanvasHeight, getCanvasWidth, PageFormat } from '@ritabygglov/core';
import { useEffect, useState } from 'react';

function resizeImage(width: number, height: number, pageFormat: PageFormat) {
  const maxWidth = getCanvasWidth(pageFormat);
  const maxHeight = getCanvasHeight(pageFormat);
  const aspectRatio = width / height;

  // Check if width exceeds the maxWidth
  if (width > maxWidth) {
    width = maxWidth;
    height = Math.floor(maxWidth / aspectRatio);
  }

  // Check if height exceeds the maxHeight
  if (height > maxHeight) {
    height = maxHeight;
    width = Math.floor(maxHeight * aspectRatio);
  }

  return { width, height };
}

export const useImageDimensions = (
  imageUrl: string,
  pageFormat: PageFormat
) => {
  const [dimensions, setDimensions] = useState<{
    width: number;
    height: number;
  }>(
    pageFormat === PageFormat.A3_LANDSCAPE ||
      pageFormat === PageFormat.A4_LANDSCAPE
      ? {
          width: 1600,
          height: 1131.45,
        }
      : {
          width: 1131.45,
          height: 1600,
        }
  );

  useEffect(() => {
    if (!imageUrl) return;
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      setDimensions(resizeImage(img.width, img.height, pageFormat));
    };

    img.onerror = (error) => {
      console.error('Failed to load image', error);
    };
  }, [imageUrl, pageFormat]);

  return dimensions;
};
